import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MagnifyingGlass, ClockCounterClockwise, FilePdf, House, DotsThree } from '@phosphor-icons/react';

const navItems = [
  { path: '/dashboard', icon: House, label: 'Home' },
  { path: '/lookup', icon: MagnifyingGlass, label: 'Lookup' },
  { path: '/reports', icon: FilePdf, label: 'Reports' },
  { path: '/history', icon: ClockCounterClockwise, label: 'History' },
];

const MobileNav = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 z-50 md:hidden safe-area-bottom"
    >
      <div className="flex items-center justify-around px-2 py-1">
        {navItems.map(({ path, icon: Icon, label }) => {
          const isActive = currentPath === path;
          return (
            <Link
              key={path}
              to={path}
              data-testid={`mobile-nav-${label.toLowerCase()}`}
              className={`flex flex-col items-center py-2 px-3 min-w-[60px] transition-colors ${
                isActive
                  ? 'text-blue-600'
                  : 'text-slate-400 active:text-slate-600'
              }`}
            >
              <Icon size={22} weight={isActive ? 'fill' : 'regular'} />
              <span className="text-[10px] mt-0.5 font-medium">{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
